import { format } from 'date-fns';

export const getStatusColor = (status) => {
  switch (status) {
    case 'NEW':
      return 'bg-warning text-dark';

    case 'RESCHEDULE':
      return 'bg-warning text-dark';

    case 'APPROVED':
      return 'bg-blue-1 text-white';

    case 'PAID':
      return 'bg-blue-1 text-white';

    case 'EXECUTION':
      return 'bg-blue-1 text-white';

    case 'DONE':
      return 'bg-success text-white';

    case 'REJECTED':
      return 'bg-danger text-white';

    case 'CANCELLED':
      return 'bg-danger text-white';

    default:
      return 'bg-blue-1 text-white';
  }
};

export const getStatusLabel = (status) => {
  switch (status) {
    case 'NEW':
      return 'BARU';

    case 'RESCHEDULE':
      return 'PENGAJUAN JADWAL';

    case 'APPROVED':
      return 'DISETUJUI';

    case 'PAID':
      return 'DIJADWALKAN';

    case 'EXECUTION':
      return 'PELAKSANAAN';

    case 'DONE':
      return 'SELESAI';

    case 'CANCELLED':
      return 'DIBATALKAN';

    case 'REJECTED':
      return 'DITOLAK';

    default:
      return 'PENGEMBALIAN';
  }
};

export const getWithdrawStatusColor = (status) => {
  switch (status) {
    case 'NEW':
      return 'bg-warning text-dark';

    case 'PROCESS':
      return 'bg-primary text-white';

    case 'DECLINED':
      return 'bg-danger text-white';

    default:
      return 'bg-success text-white';
  }
};

export const getWithdrawStatusLabel = (status) => {
  switch (status) {
    case 'NEW':
      return 'BARU';
    case 'PROCESS':
      return 'DIPROSES';
    case 'DECLINED':
      return 'DITOLAK';
    default:
      return 'SELESAI';
  }
};

export const getHistoryContent = (data) => {
  switch (data.current_status) {
    case 'NEW':
      return {
        id: data.id,
        title: 'Pesanan dibuat',
        message: 'Customer telah membuat pesanan baru',
        color: '#FFC007',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    case 'RESCHEDULE':
      return {
        id: data.id,
        title: 'Penjadwalan ulang',
        message: `Tenant mengajukan penjadwalan ulang ke tanggal ${data.remarks}`,
        color: '#FEC008',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    case 'APPROVED':
      return {
        id: data.id,
        title: 'Pesanan disetujui',
        message:
          data.remarks === 'Auto Approved'
            ? 'Pesanan disetujui otomatis oleh sistem'
            : 'Pesanan telah disetujui. menunggu pembayaran',
        color: '#13357B',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    case 'PAID':
      return {
        id: data.id,
        title: 'Pesanan dibayar',
        message: 'Customer telah berhasil melakukan pembayaran.',
        color: '#13357B',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    // case 'PAID':
    //   return 'DIBAYAR';

    // case 'EXECUTION':
    //   return 'PELAKSANAAN';

    // case 'DONE':
    //   return 'SELESAI';

    case 'CANCELLED':
      return {
        id: data.id,
        title: 'Pesanan dibatalkan',
        message: 'Customer telah membatalkan pesanan ini dengan alasan ' + data.remarks,
        color: '#DC3444',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    case 'DONE':
      return {
        id: data.id,
        title: 'Pesanan Selesai',
        message: 'Pesanan telah selesai, semua tamu berhasil terlaksana.',
        color: '#198753',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    case 'REJECTED':
      return {
        id: data.id,
        title: 'Pesanan ditolak',
        message: `Pesanan ditolak dengan alasan ${data.remarks}`,
        color: '#DC3444',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    case 'REFUND':
      return {
        id: data.id,
        title: 'Permintaan Refund',
        message: `Customer melakukan permintaan refund dengan alasan ${data.remarks}`,
        color: '#FFC007',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    case 'REFUND_DONE':
      return {
        id: data.id,
        title: 'Permintaan Pengembalian Disetujui',
        message: 'Permintaan pengembalian telah disetujui oleh admin.',
        color: '#198753',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    case 'REFUND_REJECTED':
      return {
        id: data.id,
        title: 'Permintaan Pengembalian Ditolak',
        message:
          'Permintaan pengembalian ditolak oleh Admin Sportaloka ' +
          data.remarks +
          ' Pesanan akan dilanjutkan',
        color: '#FFC007',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    case 'EXECUTION':
      const array = data.remarks
        .replace(/[\[\]']+/g, '')
        .split(', ')
        .map((item) => item.trim());
      const isExecuted = array[1] === 'executed' ? true : false;
      return {
        id: data.id,
        title: isExecuted ? 'Tamu berhasil terlaksana' : 'Tamu dijadwalkan ulang',
        message: isExecuted
          ? 'Tamu dengan nama ' + array[0] + ' berhasil terlaksana'
          : 'Tamu dengan nama ' + array[0] + ' telah dijwadlkan ulang.',
        color: '#FFC007',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    default:
      return {
        id: data.id,
        title: 'Pesanan dibuat',
        message: 'Customer telah membuat pesanan baru',
        color: '#13357B',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };
  }
};

export const getWithdrawlHistoryContent = (data) => {
  switch (data.current_status) {
    case 'NEW':
      return {
        id: data.id,
        title: 'Dibuat',
        message: `Tenant melakukan permintaan penarikan saldo.`,
        color: '#FFC007',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    case 'DECLINED':
      return {
        id: data.id,
        title: 'Ditolak',
        message: `Permintaan penarikan saldo ditolak dengan alasan "${data.remarks}"`,
        color: '#DC3444',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    case 'PROCESS':
      return {
        id: data.id,
        title: 'Diproses',
        message: `Permintaan sedang di proses oleh admin.`,
        color: '#13357B',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    case 'DONE':
      return {
        id: data.id,
        title: 'Selesai',
        message: `Permintaan penarikan saldo selesai. dana telah di transfer ke rekening yang diajukan`,
        color: '#198753',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };

    default:
      return {
        id: data.id,
        title: 'Permintaan Penarikan',
        message: 'Tenant melakukan permintaan penarikan',
        color: '#FFC007',
        date: format(data.created_at, 'dd/MM/yyyy hh:mm')
      };
  }
};
